export const isSubshell = () => !process.stdin.isTTY;
